import { useOutsideClick } from '@common/hooks'
import Button from '@common/widgets/Button'
import cx from 'classnames'
import type { ReactNode } from 'react'
import { createContext, useRef, useState } from 'react'

import classNames from './styles.module.scss'

interface IProps {
  children: ReactNode | ReactNode[]
}

export const MenuContext = createContext({
  handleCloseMenu: () => {},
})

export default function MenuButton({ children }: IProps): JSX.Element {
  const [showSettings, setShowSettings] = useState(false)

  const ref = useRef<HTMLDivElement>(null)

  const handleCloseMenu = () => setShowSettings(false)

  useOutsideClick(ref, handleCloseMenu)

  return (
    <MenuContext.Provider value={{ handleCloseMenu }}>
      <div ref={ref}>
        <Button
          className={cx(classNames.moreButton, showSettings && classNames.active)}
          width="xs"
          variant="light"
          onClick={() => setShowSettings(!showSettings)}
          data-test="app-details-btn"
        >
          <i className={classNames.moreIcon} />
        </Button>
        {showSettings && <div className={classNames.moreMenu} data-test="menu-content">
          {children}
        </div>}
      </div>
    </MenuContext.Provider>
  )
}
